import { createProvider } from '@/vue-apollo'

export const validateAndStoreResource = ({ query, validate, store }) => {
  return (to, from, next) => {
    createProvider()
      .defaultClient.query(query(to, from))
      .then(res => {
        if (validate(res)) {
          next(vm => store(res, vm))
        } else {
          next({
            path: '/not-found',
            params: {
              tenant: to.params.tenant,
            },
          })
        }
      })
      .catch(err => {
        console.log(err)
        if (err.graphQLErrors && err.graphQLErrors.length) {
          if (
            err.graphQLErrors[0].extensions &&
            err.graphQLErrors[0].extensions.code === 'invalid argument'
          ) {
            next({
              path: '/not-found',
              params: {
                tenant: to.params.tenant,
              },
            })
          } else {
            next({
              path: '/error',
              params: {
                tenant: to.params.tenant,
              },
            })
          }
        } else {
          next({
            path: '/error',
            params: {
              tenant: to.params.tenant,
            },
          })
        }
      })
  }
}
